module.exports = __webpack_public_path__ + "static/106_001-20d3a36e81a5d3ae3c21f28091f5b6f6.jpg";